window.theme = window.theme || {};
var tempalt = '';
var $variant_color_group = '';


// Timber functions
window.timber = window.timber || {};

timber.initCache = function() {
    timber.cache = {
        // General
        $html: $('html'),
        $body: $('body'),

        // Navigation
        $navigation: $('#AccessibleNav'),
        $mobileSubNavToggle: $('.mobile-nav__toggle-btn'),

        // Product Page
        $productImage: $('#ProductPhotoImg'),
        $optionSelector: $('.single-option-selector'),

        // Customer Pages
        $recoverPasswordLink: $('#RecoverPassword'),
        $hideRecoverPasswordLink: $('#HideRecoverPasswordLink'),
        $recoverPasswordForm: $('#RecoverPasswordForm'),
        $customerLoginForm: $('#CustomerLoginForm'),
        $passwordResetSuccess: $('#ResetSuccess')
    };
};

timber.init = function() {
    timber.initCache();
    timber.loginForms();

};


timber.getHash = function() {
    return window.location.hash;
};
let size_loop_ran = false;

timber.loginForms = function() {
    function showRecoverPasswordForm() {
        timber.cache.$recoverPasswordForm.show();
        timber.cache.$customerLoginForm.hide();
    }

    function hideRecoverPasswordForm() {
        timber.cache.$recoverPasswordForm.hide();
        timber.cache.$customerLoginForm.show();
    }

    timber.cache.$recoverPasswordLink.on('click', function(evt) {
        evt.preventDefault();
        showRecoverPasswordForm();
    });

    timber.cache.$hideRecoverPasswordLink.on('click', function(evt) {
        evt.preventDefault();
        hideRecoverPasswordForm();
    });

    // Allow deep linking to recover password form
    if (timber.getHash() == '#recover') {
        showRecoverPasswordForm();
    }
};

timber.resetPasswordSuccess = function() {
    timber.cache.$passwordResetSuccess.show();
};


// Initialize Timber's JS on docready
$(timber.init);

